import { Grid, Typography } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { isAfter, isSameDay } from "date-fns";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormSection from "../../../../common/components/functional/formSection/FormSection";

type Props = {
  latestSalary: Date;
};

const StopHiring = ({ latestSalary }: Props) => {
  const { t } = useTranslation();
  const { control, formState } = useFormContext();

  const validateDate = (date: Date) => {
    const isAfterCurrentSalary =
      latestSalary &&
      !isSameDay(latestSalary, date) &&
      isAfter(date, latestSalary);

    const isFutureDate =
      isSameDay(date, new Date()) || isAfter(date, new Date());

    const errorText = t("talentProfile:stopHiringErrorText");

    return (isFutureDate && isAfterCurrentSalary) || errorText;
  };

  return (
    <FormSection disablePaddingBottom>
      <Grid item xs={4} textAlign="end" maxHeight="40px" alignSelf="center">
        <Typography variant="secondary">
          {t("talentProfile:hiringEnds")}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Controller
          name="endDate"
          control={control}
          rules={{ validate: (date) => validateDate(date), required: true }}
          render={({ field }) => {
            return (
              <DesktopDatePicker
                {...field}
                format="dd.MM.yyyy"
                slotProps={{
                  textField: {
                    error: !!formState.errors?.endDate,
                    size: "small",
                  },
                }}
              />
            );
          }}
        />
      </Grid>
      <Grid item xs={4} />
      <Grid item xs={8} sx={{ paddingTop: "4px !important" }}>
        <Typography
          sx={{
            display: "inline-block",
            color:
              formState.errors?.endDate?.type === "validate"
                ? "error.main"
                : "#00000085",
          }}
          fontSize="12px"
          lineHeight="20px"
          letterSpacing="0.1px"
          maxWidth="380px"
        >
          {formState.errors?.endDate?.message?.toString() ||
            t("talentProfile:stopHiringDescription")}
        </Typography>
      </Grid>
    </FormSection>
  );
};

export default StopHiring;
